import React from 'react'
import { CardContent, CardHeader, Grid, IconButton, Typography } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import RonadIcons from '../iconComponent';

interface Props {
    data: string;
    isActive: boolean;
    label: string;
    handleClick: () => void;
    icon: string;
    iconColor: string
    color: string;
    dActiveCard: () => void
}

const useStyles = makeStyles(theme =>
    createStyles({
        cards: {
            position: 'relative',
            backgroundColor: 'white',
            padding: '14px',
            height: "100%",
            boxShadow: "4px 4px 12px rgba(181, 181, 181, 0.25)",
            transition: "all .3s",
            "&:hover": {
                transform: "scale(1.05)",
                // transform: "scaleY(1.05)",
                transition: "all .3s"
            }
        },
        boxshadow: {
            position: 'relative',
            backgroundColor: 'white',
            padding: '14px',
            transform: "scale(1.05)",
            border: "1px solid #3449B0",
            height: "100%"
        },
        iconHeader: {
            position: 'absolute',
            top: '0',
            right: '0',
        },
        cardContent: {
            marginTop: '-22px',
            display: 'flex',
        },
    })
);

const CounterCard = ({
    data,
    isActive,
    label,
    handleClick,
    icon,
    dActiveCard,
    color,
    iconColor
}: Props) => {
    const classes = useStyles();


    return (
        <Card
            className={
                isActive
                    ? classes.boxshadow
                    : classes.cards
            }
        >
            <CardHeader
                action={
                    isActive && (
                        <IconButton
                            aria-label="close"
                            onClick={dActiveCard}
                            className={classes.iconHeader}
                            data-cy="cardCloseBtn"
                        >
                            <RonadIcons name="times" className='pointer text-danger'  size={0.8}/>
                        </IconButton>
                    )
                }
            />
            <CardContent className={classes.cardContent}>
                <IconButton
                    type="submit"
                    onClick={handleClick}
                    aria-label="search"
                    style={{
                        backgroundColor: color,
                        height: '80px',
                        width: '80px',
                        borderRadius: '100%',
                        margin: '-20px 0',
                    }}
                    data-cy="progressCardBtn"
                >
                    <RonadIcons name={icon} className='pointer' size={1.7}  style={{
                        color: iconColor
                    }}/>
                </IconButton>
                <Grid
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        marginRight: '16px',
                    }}
                >
                    <Typography
                        variant="h6"
                        component="h6"
                        style={{ fontWeight: 600, marginTop: '-20px' }}
                        data-cy="processingCount"
                    >
                        {data}
                    </Typography>
                    <Typography
                        style={{
                            fontSize: '16px',
                            marginBottom: '-20px',
                            fontWeight: 550,
                            color: '#666666',
                        }}
                    >
                        {label}
                    </Typography>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default CounterCard;
